var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaseInvitado = function SvgPaseInvitado(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 47,
    fill: "none",
    viewBox: "0 0 44 47"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pase-invitado_svg__clip0_465_135)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "M19.933.948 3.583 18.005c-1.204 1.256-1.204 3.293 0 4.549L19.71 39.378a2.994 2.994 0 0 0 4.36 0L40.42 22.32c1.204-1.257 1.204-3.293 0-4.55L24.293.948a2.994 2.994 0 0 0-4.36 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#510C76",
    d: "M36.403 8.458H7.59c-1.66 0-3.005 1.403-3.005 3.134v16.781c0 1.732 1.346 3.135 3.005 3.135h28.813c1.66 0 3.004-1.403 3.004-3.134V11.592c0-1.73-1.345-3.134-3.004-3.134"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#19D3C5",
    d: "M41.664 46.64H2.336C1.042 46.64 0 45.543 0 44.201V20.568c0-1.808 1.826-2.992 3.378-2.19l18.004 11.42a2.25 2.25 0 0 0 2.106-.015l17.105-11.315c1.56-.84 3.407.345 3.407 2.167v23.552c0 1.35-1.05 2.437-2.336 2.437z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "m22.546 13.647.97 3.127c.08.247.303.42.547.42h3.148c.56 0 .79.75.338 1.087l-2.545 1.927a.62.62 0 0 0-.208.675l.97 3.127c.173.555-.438 1.02-.89.675l-2.545-1.927a.564.564 0 0 0-.676 0l-2.544 1.927c-.453.345-1.064-.12-.891-.675l.97-3.127a.62.62 0 0 0-.208-.675l-2.545-1.927c-.453-.345-.223-1.087.338-1.087h3.148a.566.566 0 0 0 .546-.42l.97-3.127a.571.571 0 0 1 1.1 0z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pase-invitado_svg__clip0_465_135"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M0 0h44v46.639H0z"
  })))));
};
export default SvgPaseInvitado;